module.exports = __webpack_public_path__ + "img/ring_g_c_null_0@2x.2fb12d98.png";